var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 879,
    viewBox: "0 0 1920 879",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1920 879L1840 781.333C1760 683.667 1600 488.333 1440 455.778C1280 423.222 1120 553.444 960 537.167C800 520.889 640 358.111 480 276.722C320 195.333 160 195.333 80 195.333H0V0H80C160 0 320 0 480 0C640 0 800 0 960 0C1120 0 1280 0 1440 0C1600 0 1760 0 1840 0H1920V879Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.deae43b90a945ae2bdb5b01dc84f9f52.svg";
export { ForwardRef as ReactComponent };